module.exports = __webpack_public_path__ + "media/images/icons/diamond-804eacaf8435e5ca0a8defb0d0521014.svg";